import { render, staticRenderFns } from "./KanbanBoard.vue?vue&type=template&id=4253b21c&scoped=true"
import script from "./KanbanBoard.vue?vue&type=script&lang=ts"
export * from "./KanbanBoard.vue?vue&type=script&lang=ts"
import style0 from "./KanbanBoard.vue?vue&type=style&index=0&id=4253b21c&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4253b21c",
  null
  
)

export default component.exports